import { Environment } from '@app/core/models';
import packageJson from '../package.json';


export const environment: Environment = {
  integrationPortalApi: {
    url: 'https://duravermeer-dev-apim.azure-api.net/integrationportalexperience',
    scope: 'a8243852-553a-41bf-8b99-b54aa94863bf/.default',
  },
  experienceApi: {
    url: 'https://duravermeer-dev-apim.azure-api.net/integrationportalexperience',
  },
  production: false,
  version: packageJson.version,
  clientId: '98d4ccb8-84c5-4dbd-94d5-6e0f467237d2', 
  tenantId: '47ef05e2-eef7-412f-b794-3b99f6ab08e7',
};

